import apiClient from '../../../services/apiClient';
import eventBus from '../../../services/globalEventBus';
import { Event } from '../models/event';

export const acceptForPrefix = (prefix: string): Promise<Event> => {
  return new Promise((resolve, reject) => {
    apiClient
      .post<string>(`/v1/easy-link/${prefix}`)
      .then(response => {
        const orgId = response.data;
        const unsubscribes: (() => void)[] = [];

        const unsubscribeAll = () => {
          unsubscribes.forEach(unsub => unsub());
        };

        unsubscribes.push(
          eventBus.subscribe('AlreadyExists', (event: Event) => {
            unsubscribeAll();
            resolve({ ...event, id: orgId });
          })
        );

        unsubscribes.push(
          eventBus.subscribe('OrgAccountMemberAdded', (event: Event) => {
            if (event.id === orgId) {
              unsubscribeAll();
              resolve(event);
            }
          })
        );

        unsubscribes.push(
          eventBus.subscribe('OrgAccountError', (event: Event) => {
            if (event.id === orgId) {
              unsubscribeAll();
              reject(event);
            }
          })
        );

        unsubscribes.push(
          eventBus.subscribe('Already Exists Error', (event: Event) => {
            unsubscribeAll();
            reject(event.code);
          })
        );
      })
      .catch(err => {
        if (err.status === 404) {
          reject('NOT_FOUND');
        } else {
          reject(err);
        }
      });
  });
};
